import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";

const statusColorMap = {
  SUCCESS: "success",
  FAILED: "error",
  IN_PROGRESS: "warning",
};

const statusLabelMap = {
  SUCCESS: "Success",
  FAILED: "Failed",
  IN_PROGRESS: "In Progress",
};

const runTypeLabelMap = {
  SCHEDULED: "Scheduled",
  MANUAL: "Manual",
};

export const payoutRunColumns = (navigate) => [
  {
    field: "id",
    headerName: "Run ID",
    width: 80,
    renderCell: ({ value, id }) => (
      <>
        {<Link underline="none" component={RouterLink} to={`/payout-history/${id}`}>
          {value}
        </Link>}
      </>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: ({ value }) => (
      <Chip
        label={statusLabelMap[value] || value}
        color={statusColorMap[value] || "default"}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: "runType",
    headerName: "Type",
    width: 110,
    renderCell: ({ value }) => (
      <Chip
        label={runTypeLabelMap[value] || value}
        size="small"
        variant="outlined"
        color={value === "MANUAL" ? "info" : "default"}
      />
    ),
  },
  {
    field: "companyId",
    headerName: "Company ID",
    width: 120,
  },
  {
    field: "transactionsProcessed",
    headerName: "Transactions",
    width: 120,
    type: "number",
  },
  // {
  //   field: "totalPayoutAmount",
  //   headerName: "Total Payout",
  //   width: 140,
  //   type: "number",
  //   renderCell: ({ value }) => (
  //     <span>{Number(value || 0).toFixed(2)}</span>
  //   ),
  // },
  // {
  //   field: "totalPayoutWithoutTax",
  //   headerName: "Payout (excl. Tax)",
  //   width: 150,
  //   type: "number",
  //   renderCell: ({ value }) => (
  //     <span>{Number(value || 0).toFixed(2)}</span>
  //   ),
  // },
  {
    field: "zynkaCommission",
    headerName: "Zynka Commission",
    width: 160,
    type: "number",
    renderCell: ({ value }) => (
      <span>{Number(value || 0).toFixed(2)}</span>
    ),
  },
  {
    field: "startedAt",
    headerName: "Started At",
    width: 200,
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "completedAt",
    headerName: "Completed At",
    width: 200,
    renderCell: ({ value }) =>
      value ? (
        <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
          <span>{yearFirstDateTimeFormat(value)}</span>
        </Tooltip>
      ) : (
        <span>—</span>
      ),
  },
  {
    field: "errorMessage",
    headerName: "Error",
    width: 200,
    renderCell: ({ value }) =>
      value ? (
        <Tooltip title={value} placement="top">
          <span style={{ color: "red" }}>
            {value.length > 40 ? `${value.substring(0, 40)}...` : value}
          </span>
        </Tooltip>
      ) : (
        <span>—</span>
      ),
  },
];

export const teamBreakdownColumns = [
  {
    field: "teamId",
    headerName: "Team ID",
    width: 100,
  },
  {
    field: "teamName",
    headerName: "Team Name",
    width: 200,
  },
  {
    field: "transactionsProcessed",
    headerName: "Transactions",
    width: 130,
    type: "number",
  },
  // {
  //   field: "totalPayoutWithTax",
  //   headerName: "Payout (incl. Tax)",
  //   width: 160,
  //   type: "number",
  //   renderCell: ({ value }) => (
  //     <span>{Number(value || 0).toFixed(2)}</span>
  //   ),
  // },
  // {
  //   field: "totalPayoutWithoutTax",
  //   headerName: "Payout (excl. Tax)",
  //   width: 160,
  //   type: "number",
  //   renderCell: ({ value }) => (
  //     <span>{Number(value || 0).toFixed(2)}</span>
  //   ),
  // },
  {
    field: "zynkaCommission",
    headerName: "Zynka Commission",
    width: 160,
    type: "number",
    renderCell: ({ value }) => (
      <span>{Number(value || 0).toFixed(2)}</span>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: ({ value }) => (
      <Chip
        label={value || "Processed"}
        color={value === "SKIPPED" ? "warning" : "success"}
        size="small"
        variant="outlined"
      />
    ),
  },
];
